<template>
    <!-- 自定义弹框签到和gift弹框 -->
  <div class="model">
    <div class="model-bag" v-show="isShowItems" @click="close"></div>
    <Transition name="fade" 
      >
      <!-- @before-enter="beforeEnter"
      @enter="enter"
      @leave="leave" -->
      <div class="model-content" v-show="isShowItems">
        <slot></slot>
      </div>
    </Transition>
  </div>
</template>
<script>
export default {
  props: {
    isShow: {
      type: Boolean,
    },
  },
  watch: {
    isShow() {
      console.log("监听");
      this.isShowItems = this.isShow;
    },
  },
  data() {
    return {
      isShowItems: this.isShow,
    };
  },
  methods: {
    close() {
      console.log("1111");
      this.$emit("close");
    },
    // beforeEnter(el) {
    //   // 重置 transform 以确保动画每次都能正确播放
    //   el.style.transform = 'scale(0)';
    // },
    // enter(el, done) {
    //   // 添加过渡类
    //   el.offsetHeight; // 强制重绘，使得动画生效
    //   el.style.transition = 'transform 0.5s ease';
    //   el.style.transform = 'scale(1)';
    //   el.addEventListener('transitionend', done);
    // },
    // leave(el, done) {
    //   // 添加过渡类
    //   el.style.transition = 'transform 0.5s ease';
    //   el.style.transform = 'scale(0)';
    //   el.addEventListener('transitionend', done);
    // }
  },
};
</script>
<style>
.model {

}
.model-bag {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  /* position: fixed; */
  top: 0;
  left: 0;
  z-index: 4;
}
.model-content {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5;
  width: 100vw;
  height: 100vh;
}
/* //淡入淡出 */
.fade-enter-active,
.fade-leave-active {
   
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>
